var gdtTableNode;

gdtTableNode = {
  attrs: {
    type: {
      "default": null
    },
    qId: {
      "default": null
    },
    sourceType: {
      "default": null
    },
    plotMode: {
      "default": null
    },
    comparisonKey: {
      "default": null
    },
    comparatorTableMode: {
      "default": null
    },
    comparatorId: {
      "default": null
    },
    outcomeId: {
      "default": null
    },
    denominator: {
      "default": null
    },
    selectedOutcomeIds: {
      "default": []
    },
    selectedInterventionIds: {
      "default": []
    },
    selectedComparisonKeys: {
      "default": []
    },
    interventionComparisonPairs: {
      "default": []
    },
    includeNetEffect: {
      "default": true
    },
    showHighlights: {
      "default": true
    },
    showThresholds: {
      "default": true
    },
    transposed: {
      "default": false
    },
    tableOrder: {
      "default": {}
    },
    selectedOutcomes: {
      "default": []
    },
    data: {
      "default": {}
    },
    expanded: {
      "default": true
    },
    manualEdit: {
      "default": false
    },
    renderMode: {
      "default": null
    },
    initialType: {
      "default": null
    }
  },
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,
  toDOM: function(node) {
    return [
      'gdt-table', {
        "class": 'gdt-table',
        'data-gdt-table': JSON.stringify(node.attrs)
      }
    ];
  },
  parseDOM: [
    {
      tag: 'gdt-table',
      getAttrs: function(dom) {
        var tableData;
        tableData = dom.getAttribute('data-gdt-table');
        if (!tableData) {
          return false;
        }
        return JSON.parse(tableData);
      }
    }
  ]
};

module.exports = gdtTableNode;
